<template>
	<div class="inner-modal inner-modal--acc">
		<div class="acc">
			<div class="acc__inner">
				<div class="acc__wishlist">
					<div class="acc__wishlist-kicker">
						<svg class="svg-inline--fa fa-heart cta-icon-left" aria-hidden="true" focusable="false" data-prefix="fasr" data-icon="heart" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path class="" fill="currentColor" d="M256 163.9L222.1 130l-24.2-24.2C181.4 89.3 159 80 135.8 80C87.3 80 48 119.3 48 167.8c0 23.3 9.2 45.6 25.7 62.1l24.2 24.2L256 412.1 414.1 254.1l24.2-24.2c16.5-16.5 25.7-38.8 25.7-62.1c0-48.5-39.3-87.8-87.8-87.8c-23.3 0-45.6 9.2-62.1 25.7L289.9 130 256 163.9zm33.9 282.2L256 480l-33.9-33.9L64 288 39.8 263.8C14.3 238.3 0 203.8 0 167.8C0 92.8 60.8 32 135.8 32c36 0 70.5 14.3 96 39.8L256 96l24.2-24.2c0 0 0 0 0 0c25.5-25.4 60-39.7 96-39.7C451.2 32 512 92.8 512 167.8c0 36-14.3 70.5-39.8 96L448 288 289.9 446.1z"></path></svg>
						<span class="acc__wishlist-add">Add to Wishlist</span>
					</div>
				</div>
				<div class="acc__wishlist-head">
					<h3 class="acc__wishlist-heading">Your Design</h3>
				</div>
				<template v-if="validationErrors.length">
					<template v-for="error in validationErrors">
						<p class="text-danger text-center">{{error}}</p>
					</template>
				</template>
				<ul class="acc__wishlist-list" v-if="wishlistItems.length">
					<template v-for="item in wishlistItems" :key="item.id">
						<li class="acc__wishlist-item" >
							<div class="acc__wishlist-card">
								<div class="acc__wishlist-image-col"><img :src="item.imageUrl" class="acc__wishlist-image"></div>
								<div class="acc__wishlist-content-col">
									<div class="acc__wishlist-content-heading">{{ item.description }}</div>
									<div class="acc__wishlist-model-number">Model Number: {{ item.modelNumber }}</div>
								</div>
							</div>
						</li>
					</template>
				</ul>
				<div class="acc__wishlists-container">
					<div class="acc__wishlist-container-col-1">Add All To:</div>
					<div class="acc__wishlist-container-col-2">
						<template v-if="wishlists.length && !addMode">
							<select name="wishlistSelection" id="wishlistSelection" :class="[`form-control`, formValidationErrors?.wishlistName?.length ? 'is-invalid' : '']" v-model="selectedWishlist">
								<option disabled selected value="">Select a Wishlist</option>
								<option v-for="wishlist in wishlists" :value="wishlist">{{ wishlist }}</option>
							</select>
							<div class="invalid-feedback" v-for="error in formValidationErrors?.wishlistName">
								&bull; {{error}}
							</div>
						</template>
						<template v-if="addMode">
							<div class="acc__wishlist-new">
								<div class="acc__wishlist-new-col-1">
									<input type="text" id="wishlistName" v-model="newWishlistName" :class="[`form-control`, formValidationErrors?.wishlistName?.length ? 'is-invalid' : '']" placeholder="Enter Wishlist Name">
									<div class="invalid-feedback" v-for="error in formValidationErrors?.wishlistName">
										&bull; {{error}}
									</div>
								</div>
								<div class="acc__wishlist-new-col-2">
									<Cta type="outline" size="lg" label="Add" @onClick="addToWishlist(newWishlistName)" :icon="[]" iconAlignment="right"> </Cta>
								</div>

								<div class="acc__wishlist-new-col-3" v-if="wishlists.length">
									<Cta type="primary" size="lg" label="Cancel" @onClick="addMode = !addMode" :icon="[]" iconAlignment="left"> </Cta>
								</div>
							</div>
						</template>
					</div>
					<div class="acc__wishlist-container-col-3" v-if="wishlists.length && !addMode">
						<Cta type="outline" size="lg" label="Add" @onClick="addToWishlist(selectedWishlist)" :icon="[]" iconAlignment="right"> </Cta>
						<Cta type="primary" size="lg" label="Create New" @onClick="addMode = !addMode" :icon="['fasr', 'fa-plus']" iconAlignment="left"> </Cta>
					</div>
				</div>

				<div class="acc__disclaimer">
					<strong>Note:</strong> Products shown are for inspiration purposes only, all product selections should be verified by a professional at one of our showrooms before ordering to ensure proper fit and that all parts will function properly together. You may locate the nearest showroom to you by visiting
					<a href="//www.baldwinhardware.com/where-to-buy">www.baldwinhardware.com/where-to-buy</a>
				</div>
			</div>
		</div>
		<button @click="closeModal" class="inner-modal__close">&times;</button>
	</div>
</template>

<script lang="ts" setup>
import {ref, watchEffect, watch} from 'vue';
const componentName = 'AddToWishlistModal';
import {WishlistItemsToAdd, WishlistItemsAdd, WishlistItems, WishlistItemDelete} from "Api/apis";
import { useStore } from 'vuex';
import Cta from "Vue/components/lockDesigner/components/shared/Cta.vue";
const store = useStore();
const wishlistItems = ref([]);
const wishlists = ref([]);
const selectedWishlist = ref('');
const newWishlistName = ref('');
const addMode = ref<boolean>(false);
const validationErrors = ref<string[]>([]);
const formValidationErrors = ref<any>({});
import {useToast} from 'vue-toastification';
const toast = useToast();

watchEffect(async () => {
	const lockDesignerWishlistItemsToAddRequest = {
		selections: store?.state?.selections,
		wishlistName: ''
	};
	const authToken = store?.state?.authToken;
	let items = await WishlistItemsToAdd(lockDesignerWishlistItemsToAddRequest, authToken);
	wishlistItems.value = items.data?.components || [];
	wishlists.value = items.data?.wishlists || [];

	if(!wishlists.value.length) {
		addMode.value = true;
	}
});


const addToWishlist = async(wishlistName) => {
	const lockDesignerWishlistItemsToAddRequest = {
		selections: store?.state?.selections,
		wishlistName: wishlistName
	};
	let response = await WishlistItemsAdd(lockDesignerWishlistItemsToAddRequest, store?.state?.authToken);
	if(response.data) {
		formValidationErrors.value = {};
		await toast.success(`You successfully saved your items to your wishlist`, {
			timeout: 2000
		});
		await store.dispatch('closeModal');
	} else {
		if(response.isErrors) {
			if(response.errorDetail.isError) {
				validationErrors.value = response.userFriendlyMessages;
			}
			if(response.formValidationMessages) {
				formValidationErrors.value = response.formValidationMessages;
			}
		} else {
			formValidationErrors.value = {};
		}
	}
}

watch(addMode, (newValue, oldValue) => {
	formValidationErrors.value = {};
});

const closeModal = async() => {
	await store.dispatch('closeModal');
};
</script>
